// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"35":"files-page","371":"profile-page","593":"users-list-page","625":"map-page","770":"projects-list-page","863":"project-details-page","996":"dashboard-page"}[chunkId] + ".bundle.js";
};